<div class="h-100" style="width: 560px; background-color: var(--dx-color-border);">
  <div class="panel-title">{{ containerName }}</div>
  <ng-container *ngIf="container?.logoLink">
    <img [src]="container?.logoLink" alt="Logo" class="title-logo" />
  </ng-container>

  <ng-container [ngSwitch]="context">
    <np-inspect-container-details-context
      *ngSwitchCase="'containerDetails'"
      [container]="container"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-details-context>

    <np-inspect-container-catalog
      *ngSwitchCase="'containerCatalog'"
      [container]="container"
      [catalogId]="catalogId"
      (containerSaved)="containerSaved.emit($event)">
    </np-inspect-container-catalog>
  </ng-container>
</div>
